export const GET_COMPANIES = "GET_COMPANIES";
export const FILTER_COMPANIES = "FILTER_COMPANIES";
export const ADD_COMPANIE = "ADD_COMPANIE";
export const EDIT_COMPANIE = "EDIT_COMPANIE";
export const GET_COMPANIE = "GET_COMPANIE";
export const RESET_COMPANIE = "RESET_COMPANIE";
export const COMPANIES_ERROR = "COMPANIES_ERROR";
